import React from 'react';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { useSpace } from '@bubble-ui/hook-use-styles';
import { Typography } from '@bubble-ui/molecule-typography';
import { View } from '@bubble-ui/primitive-view';
import { PropsContextProvider } from '@bubble-ui/provider-props-context';
import { defaultComponentTokens } from './defaultComponentTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
export var mapTypographyElement = _ref => {
  var {
    element,
    textColorToken,
    textColorTokenArgs,
    textStyleToken
  } = _ref;
  return typeof element === 'string' && element.length > 0 || typeof element === 'number' ? /*#__PURE__*/React.createElement(Typography, {
    shrink: true,
    colorToken: textColorToken,
    colorTokenArgs: textColorTokenArgs,
    textAlignToken: "text-alignment/center",
    textToken: textStyleToken
  }, element) : element;
};
var Separator = _ref2 => {
  var {
    children,
    colorToken = 'separator/border-color',
    colorTokenArgs,
    labelGap: labelGapProp = 'space/200',
    separatorMinWidthBeforeAndAfterLabel: separatorMinWidthBeforeAndAfterLabelProp = 'space/800',
    textColorToken = 'separator/text-color',
    textColorTokenArgs
  } = _ref2;
  var designContext = useDesignContext(defaultComponentTokens);
  var labelGap = useSpace(labelGapProp);
  var separatorMinWidthBeforeAndAfterLabel = useSpace(separatorMinWidthBeforeAndAfterLabelProp);
  var {
    rootStyle,
    separatorWrapperStyle,
    separatorStyle
  } = getDefaultStyleSheet({
    colorToken,
    colorTokenArgs,
    designContext,
    labelGap,
    separatorMinWidthBeforeAndAfterLabel
  });

  // Filter out falsy children
  var filteredChildren = React.Children.toArray(children);
  if (filteredChildren.length) {
    return /*#__PURE__*/React.createElement(View, {
      style: rootStyle
    }, /*#__PURE__*/React.createElement(View, {
      style: separatorWrapperStyle
    }, /*#__PURE__*/React.createElement(View, {
      style: separatorStyle
    })), /*#__PURE__*/React.createElement(PropsContextProvider, {
      props: {
        Typography: {
          colorToken: textColorToken,
          colorTokenArgs: textColorTokenArgs,
          textToken: 'separator/text-style'
        },
        Icon: {
          colorToken: textColorToken,
          colorTokenArgs: textColorTokenArgs
        },
        ActionIcon: {
          colorToken: textColorToken,
          colorTokenArgs: textColorTokenArgs
        }
      }
    }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
      context: designContext
    }, React.Children.map(filteredChildren, child => mapTypographyElement({
      element: child,
      textColorToken,
      textColorTokenArgs,
      textStyleToken: 'separator/text-style'
    })))), /*#__PURE__*/React.createElement(View, {
      style: separatorWrapperStyle
    }, /*#__PURE__*/React.createElement(View, {
      style: separatorStyle
    })));
  }
  return /*#__PURE__*/React.createElement(View, {
    style: separatorStyle
  });
};
Separator.displayName = 'Separator';
export { Separator };
//# sourceMappingURL=index.js.map